module.exports = ".padBottom {\n    padding-bottom: 15px;\n}\n\n.centered {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 35%;\n    transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    font-size: 20px;\n    padding: 2%;\n    z-index: 100;\n}\n\n.btn.btn-outline {\n    width: auto;\n    height: auto;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/myprofile/view-bill/view-bill.component.css
// module id = ./src/app/myprofile/view-bill/view-bill.component.css
// module chunks = main